import { ApiTaskType } from "src/api/types";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";

interface TaskTypeIndicatorProps extends Translation {
	type: ApiTaskType;
}

const TaskTypeIndicator = ({ t, type }: TaskTypeIndicatorProps) => {
	const themes: any = {
		INTERNAL: {
			icon: "bg-dark opacity-20",
			label: "text-dark opacity-20",
		},
		PUBLISHED: {
			icon: "bg-green",
			label: "text-green",
		},
		DRAFT: {
			icon: "bg-gray",
		},
	};
	const theme = themes[type];
	// if (type !== "PUBLISHED") return <span></span>;
	return (
		<div className="flex items-center gap-1">
			<div className={`w-2 h-2 rounded-full ${theme?.icon}`}></div>
			<span className={`lowe text-[14px] font-bold ${theme?.label}`}>
				{t(type)}
			</span>
		</div>
	);
};

TaskTypeIndicator.locale = {
	nl: {
		INTERNAL: "Intern",
		PUBLISHED: "Uitbesteed",
		DRAFT: "Concept",
	},
	en: {
		INTERNAL: "Internal",
		PUBLISHED: "Published",
		DRAFT: "Draft",
	},
};

export default withTranslation(TaskTypeIndicator);
